var _style, _g, _g2, _g3, _ellipse, _path, _path2, _path3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEbv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1862.1 366.2",
    style: {
      enableBackground: "new 0 0 1862.1 366.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#70787D;}\r\n\t.st1{fill:#005595;}\r\n\t.st2{enable-background:new    ;}\r\n\t.st3{fill:url(#SVGID_1_);}\r\n\t.st4{fill:url(#SVGID_2_);}\r\n\t.st5{opacity:0.49;fill:url(#SVGID_3_);}\r\n\t.st6{fill:url(#SVGID_4_);}\r\n\t.st7{fill:#003D6E;}\r\n\t.st8{fill:url(#SVGID_5_);}\r\n\t.st9{fill:url(#SVGID_6_);}\r\n\t.st10{fill:url(#SVGID_7_);}\r\n\t.st11{fill:#003461;}\r\n\t.st12{fill:url(#SVGID_8_);}\r\n\t.st13{fill:url(#SVGID_9_);}\r\n\t.st14{fill:url(#SVGID_10_);}\r\n\t.st15{fill:url(#SVGID_11_);}\r\n\t.st16{fill:url(#SVGID_12_);}\r\n\t.st17{fill:url(#SVGID_13_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "962,69.3 962,83.9 894.5,83.9 894.5,144.6 958.4,144.6 958.1,158.9 894.2,158.9 894.2,226.1  964.4,226.1 964.2,240.4 877.8,240.4 877.8,69.3 962,69.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1010.4,240.4 994.7,240.2 994.7,70.7 1010.4,70.7 1010.4,240.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1055.3,181.6c1.2,15.5,3.2,21.1,8.2,28.8c1.5,2.4,3.6,6,9.9,10.9c5.6,3.9,13.8,7.7,26.6,7.7 c12.8,0,21.3-3.6,33.9-9.2l0.5,16c-7.3,2.4-18.1,6.8-34.8,6.8c-3.9,0-7.3-0.2-10.9-0.7c-13.1-1.5-26.4-6.5-36.5-20.1 c-6.1-8-12.8-22.7-12.8-43.3c0-3.4,0.2-21.8,8-36.5c3.1-6,6.8-9.9,9-12.3c6-6.3,14-12.6,28.1-14.8c3.1-0.7,6.3-1,9.7-1 c3.1,0,23,0.2,36.8,16.7c4.4,5.1,7.5,12.3,9.4,18.1c2.7,8.7,4.1,15.7,3.1,32.9H1055.3L1055.3,181.6z M1128.3,169 c-0.5-5.6-1.2-11.1-2.7-16.7c-0.7-2.7-3.6-13.8-15-20.8c-4.8-2.9-7-3.9-15.7-4.6c-10.4,0.7-14.3,1.9-19.8,5.3 c-0.5,0.5-3.9,2.7-6.3,5.1c-1.7,1.7-3.1,3.4-5.3,7.3c-6.8,11.1-7.5,21.1-8,24.4H1128.3L1128.3,169z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1188.2,165.9l56.6-49.6h19.1l-61,54l69.2,70.2l-20.8-0.2c-15.2-15.2-29.8-29.8-44.8-45 c-6.3-6.5-12.1-11.9-18.4-18.6v63.6h-15.7v-169h15.7V165.9L1188.2,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1312.3,116.3h29.3v13.1H1312c0,25.2-0.2,49.8,0,75c0,1.5-0.2,9,2.2,15c2.2,4.4,8.5,9.2,16.7,9.2 c3.1,0,5.8-0.5,12.1-2.7l0.5,13.5c-8.5,2.2-10.9,2.7-15.7,2.7c-7.3,0-12.6-1.7-15.2-2.9c-2.2-0.7-4.6-2.4-6.5-4.1 c-3.6-2.9-5.1-5.8-5.8-7c-4.3-8.5-3.6-20.3-3.6-28.8c0-7.7,0-15.5-0.2-23.2v-46.9h-21.8v-12.8h22V86l15.7-5.3V116.3L1312.3,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1383.1,146.5c0.7-3.2,1.5-7.5,6-14.8c4.8-7.3,13.3-16.5,28.1-16.5c2.4,0,4.8,0.2,7.5,0.5v15.7 c-2.4-0.2-5.1-0.7-7.7-0.7c-2.7,0-11.4,0-19.8,8.5c-2.2,2.2-4.1,4.8-5.3,7c-8.2,14.3-6.8,36-6.8,50.1v44h-15.7 c0-17.4,0-34.6,0.2-52c0-16.9,0.2-33.9-0.2-50.8c0-7-0.2-14.3-0.7-21.3h14.5V146.5L1383.1,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1527.4,127.4c6.5,5.6,9.4,9.7,12.3,15.5c4.1,7.7,7.5,17.2,7.5,33.9c0,5.3,0,17.2-5.8,31.5 c-0.2,1-2.4,5.8-5.1,9.9c-1.9,2.9-9.2,12.6-19.4,18.2c-10.4,5.8-24.9,6.3-27.1,6.3c-4.1,0-13.5-0.5-25.2-6.3 c-3.4-1.7-5.8-3.2-8.7-5.3c-1.2-1-4.8-3.9-8.2-8.2c-1.9-2.2-4.6-5.8-7-10.9c-6.3-13.3-6.5-29.8-6.5-32.9 c0-26.1,12.1-45.5,24.9-54.4c6.1-4.1,15.5-9.4,30-10.2C1507.3,113.6,1519.9,120.9,1527.4,127.4L1527.4,127.4z M1469.1,135.4 c-3.1,2.7-6.5,6.5-7,7c-5.3,7-12.1,20.3-12.1,37.7c0,18.9,7.5,32.2,14,38.7c4.6,4.4,13.5,10.9,25.6,10.9c9.2,0,16-3.2,19.4-5.3 c3.4-2.2,6.5-5.3,7.5-6.3c1.5-1.7,3.9-4.3,6.3-8c3.9-6.3,9.2-18.4,9.2-34.1c0-3.1-0.2-16.2-6.3-27.6c-1.5-2.4-4.1-7-10.2-12.3 c-4.6-3.9-13.3-9.7-26.1-9C1486.5,127.4,1478.3,127.9,1469.1,135.4L1469.1,135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1656.7,240.2v-61c0-10.4,0.7-28.1-6.3-39.4c-3.2-5.1-10.4-11.6-22.3-11.6c-4.6,0-11.6,1.7-16.5,4.6 c-2.9,1.7-8.7,5.8-13.3,13.3c-8,12.3-7.5,27.6-7.5,39.9c0,18.1-0.2,36.3-0.2,54.4h-15c0-26.4-0.2-53-0.2-79.4 c0-8.7,0.2-17.2,0-25.7c0-6.3-0.5-12.8-0.7-18.9h13.8v27.1c1.9-5.6,3.4-9.2,8.2-14.5c2.9-3.4,6.5-6.3,7.3-7 c4.6-3.4,14.5-7.5,26.9-7.5c3.9,0,21.3,0,32.9,16.2c4.8,6.8,7.3,16.7,8,23.7c0.2,4.8,0.2,9.7,0.2,14.3c0,4.6,0.2,9.2,0.2,13.5 c0,9.9-0.2,19.8-0.2,29.5c0.2,9.4,0.2,19.1,0,28.6L1656.7,240.2L1656.7,240.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1725.9,73.8v20.6h-17.7V73.8H1725.9L1725.9,73.8z M1724.7,116.3v123.9H1709V116.3H1724.7L1724.7,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1778.1,165.9l56.6-49.6h19.1l-61,54l69.2,70.2l-20.8-0.2c-15.2-15.2-29.8-29.8-44.8-45 c-6.3-6.5-12.1-11.9-18.4-18.6v63.6h-15.7v-169h15.7V165.9L1778.1,165.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.8,236.9V66.4h66.3c5.3,0,10.6,0,15.7,0.2c9.9,0.5,51.3,2.4,51.3,43.8c0,5.3-0.2,18.4-11.1,28.6 c-6.1,5.8-11.9,8-19.1,10.9c1.7,0.5,10.9,2.4,16.9,6c12.3,7,18.6,20.3,18.6,34.8c0,7.7-1.9,25.2-20.6,36.1 c-15.5,9.2-33.4,9.7-50.3,10.2H526.8L526.8,236.9z M571.8,97.8v37.5H588c1.5,0,3.1-0.2,4.6-0.2c2.9-0.2,12.3-0.7,18.6-8 c2.4-2.9,4.1-6.8,4.1-10.6c0-2.9-1-6.5-2.7-9c-4.8-7.7-12.8-8.7-21.5-9.7H571.8L571.8,97.8z M571.8,165.8v39.4h25.2 c3.6-0.2,5.6-0.2,9-1.5c11.6-3.9,13.8-14.3,13.8-18.6c0-6.5-3.9-12.1-9.4-15.7c-5.8-3.6-12.3-3.6-19.4-3.6H571.8L571.8,165.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M847.5,67.1l-55.7,169.8h-57.1L677.7,67.1l48.6,0.2c5.3,17.4,10.4,34.6,15.7,52c3.4,10.6,6.8,21.3,9.7,32.2 c4.6,15.7,8.7,31.7,12.8,47.7c3.6-16,7.3-31.9,11.9-47.9c4.4-16.2,9.7-32.2,14.3-48.2c3.4-11.9,6.5-23.9,9.9-36H847.5L847.5,67.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.5,67.1 489.5,99.8 415,99.8 415,134.1 484.9,134.1 484.9,166.3 415,166.3 415,204 492.2,204  492.2,236.7 369.5,236.7 369.5,67.1 489.5,67.1  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M879.6,350.5v-57h8.5v57H879.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M982.5,350.5l-4.8-13.5h-22.8l-4.7,13.5h-8.9l20.5-57h9l20.8,57H982.5z M970.5,316.2 c-1.4-4.1-3.7-10.7-4.3-13.1c-0.6,2.4-2.7,9-4.2,13.2l-4.6,13h17.6L970.5,316.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1037.3,350.5v-24.2c0-8.6-3.3-11.7-8.8-11.7c-5.6,0-8.8,4-8.8,10.9v25h-8.4v-42.7h8.4v4.1 c2.1-3.1,6.4-5,10.7-5c9.9,0,15.2,6.5,15.2,19.1v24.5H1037.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1138.1,350.5l-4.8-13.5h-22.8l-4.7,13.5h-8.9l20.5-57h9l20.8,57H1138.1z M1126.1,316.2 c-1.4-4.1-3.7-10.7-4.3-13.1c-0.6,2.4-2.7,9-4.1,13.2l-4.6,13h17.6L1126.1,316.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1181.4,350.5h-8.4l-15.3-42.7h8.8l7.6,23.2c1.4,4.2,2.6,8.1,3.2,10.5c0.5-2.4,1.6-6.3,2.9-10.5l7.3-23.2h8.9 L1181.4,350.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1241.1,350.5v-24.2c0-8.6-3.3-11.7-8.8-11.7c-5.6,0-8.8,4-8.8,10.9v25h-8.4v-42.7h8.4v4.1 c2.1-3.1,6.4-5,10.7-5c9.9,0,15.2,6.5,15.2,19.1v24.5H1241.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1305.7,332.1h-28.2c0.9,8.2,5.5,11.7,10.7,11.7c3.6,0,6.4-1.3,9.3-3.4l5,5.4c-3.7,3.6-8.2,5.6-14.7,5.6 c-10,0-18.5-8.1-18.5-22.2c0-14.5,7.6-22.3,18.7-22.3c12.1,0,18,9.8,18,21.4C1305.9,329.8,1305.8,331.2,1305.7,332.1z  M1287.4,314.4c-5.6,0-9,3.9-9.8,10.7h19.9C1297.1,319.3,1294.3,314.4,1287.4,314.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1345.9,349.4c-2,1.1-4.9,2-8.2,2c-5.9,0-9.6-3.7-9.6-11.3v-24.7h-6.1v-7.7h6.1v-12.2l8.2-4.4v16.6h10.6v7.7 h-10.6v23.2c0,4,1.3,5.1,4.4,5.1c2.2,0,4.6-0.8,6.2-1.7L1345.9,349.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1422.4,351.4c-14.7,0-24.1-12.1-24.1-29.4c0-17.3,9.4-29.4,24.1-29.4c9.3,0,15.5,3.7,19.4,10.7l-7.6,4.7 c-2.9-4.6-5.9-6.8-11.8-6.8c-9.9,0-15.3,8.1-15.3,20.8c0,12.8,5.4,20.8,15.3,20.8c5.9,0,9.6-2.4,12.5-7.1l7.1,4.7 C1437.9,347.5,1431,351.4,1422.4,351.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1478,351.4c-10.7,0-18.8-8.9-18.8-22.2c0-14,8.3-22.3,19-22.3c10.9,0,19,8.7,19,22.1 C1497.2,343.1,1488.9,351.4,1478,351.4z M1477.9,314.8c-6.3,0-10.3,5.6-10.3,14.1c0,9.4,4.3,14.5,10.7,14.5 c6.3,0,10.5-6.4,10.5-14.2C1488.8,320.5,1484.6,314.8,1477.9,314.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1567,350.5v-24.2c0-8.6-2.7-11.7-8.2-11.7c-5.6,0-8.2,4-8.2,10.9v25h-8.4v-24.2c0-8.6-2.7-11.7-8.2-11.7 c-5.6,0-8.2,4-8.2,10.9v25h-8.4v-42.7h8.4v4.1c2.1-3.1,5.8-5,10.2-5c5.8,0,9.4,2.2,11.7,6.3c3.1-3.8,6.4-6.3,13.1-6.3 c9.9,0,14.6,6.5,14.6,19.1v24.5H1567z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1616.2,351.4c-4.3,0-8.4-2.3-10.7-4.9v15.4l-8.3,4.3v-58.4h8.3v4.1c3.1-2.8,6.7-5,11.1-5 c9.2,0,16.4,6.7,16.4,23C1633.1,344.5,1625.1,351.4,1616.2,351.4z M1615.1,314.6c-4,0-7.5,2.7-9.7,5.5v18c1.9,2.5,5.8,5.6,10,5.6 c6,0,9.3-4.6,9.3-13.6C1624.7,319.3,1621.3,314.6,1615.1,314.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1677.2,350.5v-4.2c-2.9,2.9-7.1,5.1-11.7,5.1c-6.9,0-14.8-3.9-14.8-14.4c0-9.5,7.3-13.8,17-13.8 c4,0,7.2,0.6,9.5,1.6v-3.2c0-4.6-2.8-7.2-8.1-7.2c-4.4,0-7.8,0.8-11.1,2.7l-3.3-6.3c4.1-2.5,8.6-3.8,14.7-3.8c9.5,0,16,4.6,16,14.3 v29.3H1677.2z M1677.2,332.3c-2.3-1.1-5.2-1.9-9.8-1.9c-5.4,0-8.8,2.4-8.8,6.3c0,4.2,2.7,7.1,8.2,7.1c4.5,0,8.4-2.8,10.3-5.5V332.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1733.1,350.5v-24.2c0-8.6-3.3-11.7-8.8-11.7c-5.6,0-8.8,4-8.8,10.9v25h-8.4v-42.7h8.4v4.1 c2.1-3.1,6.4-5,10.7-5c9.9,0,15.2,6.5,15.2,19.1v24.5H1733.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1776.6,365.5h-8.9l6.2-15.9l-15.7-41.9h9.2l7,20.9c1.3,3.7,3.3,10.1,3.7,12.4c0.7-2.5,2.5-8.6,3.8-12.3 l7.2-21.1h8.9L1776.6,365.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1850.1,350.5v-57h8.5v57H1850.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 133.8215,
    cy: 145.9268,
    r: 145.8058,
    fx: 108.3551,
    fy: 145.9908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06936937,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4908,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7325,
    style: {
      stopColor: "#FDFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8195,
    style: {
      stopColor: "#F7F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8816,
    style: {
      stopColor: "#EDEEF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9318,
    style: {
      stopColor: "#DFE0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9742,
    style: {
      stopColor: "#CCCED2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BDC0C5"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 151.7,
    cy: 151.7,
    rx: 151.7,
    ry: 151.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 119.5469,
    cy: 149.8093,
    r: 114.6272,
    fx: 99.5262,
    fy: 149.8596,
    gradientTransform: "matrix(0.9883 0 0 0.9916 10.881 1.6924)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4349,
    style: {
      stopColor: "#F5F6F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5767,
    style: {
      stopColor: "#E8EBED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7034,
    style: {
      stopColor: "#D5DADD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8201,
    style: {
      stopColor: "#BEC5C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    style: {
      stopColor: "#A1AAAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A9399"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M56.7,151.7c0-52.8,40.9-95.6,95.3-95.6c52.6,0,95.3,42.8,95.3,95.6c0,54.6-42.7,95.6-95.3,95.6 C97.2,247.3,56.7,204.5,56.7,151.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 175.0114,
    cy: 158.886,
    r: 122.1612,
    fx: 171.6372,
    fy: 158.8806,
    gradientTransform: "matrix(0.9883 0 0 0.9916 10.881 1.6924)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4026,
    style: {
      stopColor: "#FDFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    style: {
      stopColor: "#F7F8F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    style: {
      stopColor: "#EDEFF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7346,
    style: {
      stopColor: "#DFE2E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8062,
    style: {
      stopColor: "#CCD1D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8696,
    style: {
      stopColor: "#B5BBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9269,
    style: {
      stopColor: "#99A0A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9778,
    style: {
      stopColor: "#798186"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9939,
    style: {
      stopColor: "#6E757A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M56.7,151.7c0-52.8,40.9-95.6,95.3-95.6c52.6,0,95.3,42.8,95.3,95.6c0,54.6-42.7,95.6-95.3,95.6 C97.2,247.3,56.7,204.5,56.7,151.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 149.5602,
    cy: 150.5907,
    r: 117.305,
    fx: 230.2382,
    fy: 150.5896,
    gradientTransform: "matrix(1 0 0 0.9482 0 7.928)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4C1D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2563,
    style: {
      stopColor: "#B1BFD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#A6B8D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5303,
    style: {
      stopColor: "#95ACC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    style: {
      stopColor: "#7D9CBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7377,
    style: {
      stopColor: "#5D88A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8295,
    style: {
      stopColor: "#337095"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9146,
    style: {
      stopColor: "#00587F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#004066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#003E64"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M151.9,49.9C95.2,49.9,49.8,94.3,49.8,152c0,56.7,45,101.3,101.7,101.8c63.7,0.5,102-50.2,102.8-102.1 C255.2,98.2,209.8,49.9,151.9,49.9z M151.7,246c-54.6,0-93.2-39.8-93.2-94.3c0-54.6,38.6-94.3,93.2-94.3 c54.6,0,94.3,39.8,94.3,94.3C246,206.2,206.2,246,151.7,246z"
  })), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "162.7,164.1 168.4,169.9 168.4,219.6 162.7,214  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.6939,
    y1: 136.4585,
    x2: 253.4078,
    y2: 136.4585
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00457C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    style: {
      stopColor: "#005287"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2855,
    style: {
      stopColor: "#2C6697"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4617,
    style: {
      stopColor: "#4E77A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6389,
    style: {
      stopColor: "#6385AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8175,
    style: {
      stopColor: "#708EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7491B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "162.7,139.2 168.4,133.7 244.5,133.7 253.4,139.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.5503,
    y1: 177.7001,
    x2: 141.9185,
    y2: 177.7001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00457C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    style: {
      stopColor: "#005287"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2855,
    style: {
      stopColor: "#2C6697"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4617,
    style: {
      stopColor: "#4E77A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6389,
    style: {
      stopColor: "#6385AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8175,
    style: {
      stopColor: "#708EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7491B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "63.6,203.4 67.1,193.6 130.3,152 141.9,152.1  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 130.3094,
    cy: 190.3387,
    r: 22.5937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003461"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7491B7"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "140.3,214 134.7,219.6 134.7,193.1 140.3,181.6  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "140.3,181.6 134.7,193.1 88.7,223.2 77.9,222.5  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "162.7,214 168.4,219.6 134.7,219.6 140.3,214  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 167.6503,
    cy: 148.9976,
    r: 257.0818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00325E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1117,
    style: {
      stopColor: "#003F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3969,
    style: {
      stopColor: "#2F618F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6503,
    style: {
      stopColor: "#5A7FAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#7594BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F9CC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "253.5,164.1 244.4,169.9 168.4,169.9 162.7,164.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.7305,
    y1: 104.4409,
    x2: 140.3384,
    y2: 104.4409
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84A3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D9BBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7693B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7491B7"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "140.3,124.3 134.7,113.4 134.7,84.6 140.3,90.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.0352,
    y1: 103.1078,
    x2: 140.3384,
    y2: 103.1078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00457C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    style: {
      stopColor: "#005287"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2855,
    style: {
      stopColor: "#2C6697"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4617,
    style: {
      stopColor: "#4E77A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6389,
    style: {
      stopColor: "#6385AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8175,
    style: {
      stopColor: "#708EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7491B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "77,82.4 86.7,81.9 134.8,113.4 140.3,124.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.7305,
    y1: 87.6189,
    x2: 168.3599,
    y2: 87.6189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7491B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "140.3,90.7 134.7,84.6 168.4,84.6 162.7,90.7  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "162.7,90.7 168.4,84.6 168.4,133.7 162.7,139.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.711,
    y1: 126.1799,
    x2: 141.9185,
    y2: 126.1799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00457C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    style: {
      stopColor: "#005287"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2855,
    style: {
      stopColor: "#2C6697"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4617,
    style: {
      stopColor: "#4E77A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6389,
    style: {
      stopColor: "#6385AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8175,
    style: {
      stopColor: "#708EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7491B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "141.9,152.1 130.3,152 66.9,110.1 63.7,100.3  "
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 134.251,
    cy: 138.4271,
    r: 137.6084,
    fx: 56.961,
    fy: 138.8632,
    gradientTransform: "matrix(0.9999 0 0 0.9999 0.2203 -0.1479)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2393,
    style: {
      stopColor: "#7F9CC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3505,
    style: {
      stopColor: "#7796BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    style: {
      stopColor: "#6285B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6603,
    style: {
      stopColor: "#3F6C99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#004E7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00325E"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M151.6,24.5c70.2,0,127.2,56.9,127.2,127.2c0,70.2-57,127.2-127.2,127.2c-70.2,0-127.2-57-127.2-127.2 C24.4,81.4,81.3,24.5,151.6,24.5z M151.9,253.3c51.9,1.1,93.1-34.9,101.5-89.1h-90.8V214h-22.4v-32.3l-62.5,40.9 C99.6,243.4,124.5,253.3,151.9,253.3 M151.9,49.9c-27.9,0-56.1,12-74.9,32.5l63.3,41.9V90.7h22.4v48.6h90.7 C247.3,88.9,202.5,49.9,151.9,49.9 M49.8,152c0,17.3,4.3,33.5,13.7,51.4l78.4-51.3l-78.2-51.8C54.1,118.2,49.8,134.6,49.8,152"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbv);
export default __webpack_public_path__ + "static/media/EBV.c79366cba8d8fac41995032ad26f10af.svg";
export { ForwardRef as ReactComponent };